import AppUserInformationState from "../model/AppUserInformationState";
import AppConfig from "../helpers/AppConfig";
import BaseService from "./BaseService";

export default class AppUserService extends BaseService{

    public static async getAppUserInformation(): Promise<AppUserInformationState> {
        return await fetch(AppConfig.PowFormUrl + '/api/database/databaseAppSidebar', await this.generatePostRequest({})) // TODO:
        .then(async response => {
            if ((!response.ok && response.status === 401) || !response.ok) {
                return new AppUserInformationState();
            }

            let responseObject = await response.json();

            if (responseObject.processed !== undefined && !responseObject.processed) {
                return new AppUserInformationState();
            }

            return new AppUserInformationState(true, responseObject.displayName, responseObject.profilePhoto, responseObject.totalApps);
        })
        .catch(error => {
            return new AppUserInformationState();
        });
    }
}
